<div class="flex flex-column">
  <p>Cuestionario para la propuesta de seguro de viaje</p>

  <div class="mt-4 page">
    <form [formGroup]="seguroViajeForm">
      <p-fieldset
        legend="1.	Nombre completo de la empresa incluyendo cualquier subsidiaria"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="name"
            class="col-12"
            labelText="Nombre completo"
            labelFor="name"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="nif"
            class="col-12 md:col-6 lg:col-4"
            labelText="CIF/DNI de la empresa"
            labelFor="nif"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="nombre_director"
            class="col-12 md:col-6 lg:col-4"
            labelText="Nombre del director"
            labelFor="nombre_director"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset legend="2. Dirección" styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="calle"
            class="col-12 md:col-6 lg:col-4"
            labelText="Calle"
            labelFor="calle"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="numero"
            class="col-12 md:col-6 lg:col-4"
            labelText="Número"
            labelFor="numero"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="piso"
            class="col-12 md:col-6 lg:col-4"
            labelText="Piso/puerta"
            labelFor="piso"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="cp"
            class="col-12 md:col-6 lg:col-4"
            labelText="Código postal"
            labelFor="cp"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="ciudad"
            class="col-12 md:col-6 lg:col-4"
            labelText="Ciudad"
            labelFor="ciudad"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="telefono"
            class="col-12 md:col-6 lg:col-4"
            labelText="Teléfono"
            labelFor="telefono"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="email"
            class="col-12 md:col-6 lg:col-4"
            labelText="EMail"
            labelFor="email"
            [group]="seguroViajeForm"
            [required]="true">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset
        legend="3. Por favor detallar la siguiente información del viaje:"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="País o países que van a visitar"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Duración del viaje"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Fecha de nacimiento"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <div class="col-12">
            <p-divider></p-divider>
            <p>
              En caso de ser más de una persona, facilitar los datos de todos
              los viajeros:
            </p>
          </div>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Nombre completo"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="DNI"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Fecha de nacimiento"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <div class="col-12 lg:hidden">
            <p-divider></p-divider>
          </div>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Nombre completo"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="DNI"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Fecha de nacimiento"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <div class="col-12 lg:hidden">
            <p-divider></p-divider>
          </div>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Nombre completo"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="DNI"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-6 md:col-4"
            labelText="Fecha de nacimiento"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-divider />
      <p>
        <strong
          >Mediante la presente acepto que se me cargue en la cuenta corriente
          que describo debajo los recibos que me pasará al cobro Consultores
          Segursub S.L. o las aseguradoras con las que colaboren sobre los
          contratos de seguros realizados por ésta empresa / persona física así
          como las renovaciones de los mismos.
        </strong>
      </p>

      <p-fieldset styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-2"
            labelText="IBAN"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-2"
            labelText="Banco"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-2"
            labelText="Sucursal"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-2"
            labelText="D.C."
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="comun"
            class="col-12 sm:col-4"
            labelText="Nº. de cuenta"
            labelFor="comun"
            [required]="false"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <p-fieldset legend="En nombre del solicitante" styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="firma"
            class="col-12 md:col-6"
            labelText="Firma"
            labelFor="firma"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>

          <!-- <ls-form-field-molecule
              formName="fecha"
              class="col-12 md:col-6"
              labelText="Fecha"
              labelFor="fecha"
              [required]="true"
              [group]="seguroViajeForm">
            </ls-form-field-molecule> -->

          <div class="col-12 md:col-6 lg:col-4">
            <div class="flex flex-column gap-2 field">
              <ls-label-atom for="fecha" text="Fecha " [required]="true">
              </ls-label-atom>

              <p-calendar
                formControlName="fecha"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [showButtonBar]="true"
                [readonlyInput]="true"
                [required]="true"
                styleClass="w-full">
                <ng-template pTemplate="inputicon">
                  <i class="ph ph-calendar-blank pointer-events-none"></i>
                </ng-template>
              </p-calendar>
            </div>
          </div>

          <ls-form-field-molecule
            formName="cargo_empresa"
            class="col-12 md:col-6"
            labelText="Cargo en la empresa"
            labelFor="cargo_empresa"
            [required]="true"
            [group]="seguroViajeForm">
          </ls-form-field-molecule>
          <!--
            <ls-form-field-molecule
              formName="fecha_inicio_seguro"
              class="col-12 md:col-6"
              labelText="Fecha inicio del seguro"
              labelFor="fecha_inicio_seguro"
              [required]="true"
              [group]="seguroViajeForm">
            </ls-form-field-molecule> -->

          <div class="col-12 md:col-6 lg:col-4">
            <div class="flex flex-column gap-2 field">
              <ls-label-atom
                for="fecha_inicio_seguro"
                text="Fecha de inicio del seguro"
                [required]="true">
              </ls-label-atom>

              <!-- [defaultDate]="defaultDate" -->
              <p-calendar
                formControlName="fecha_inicio_seguro"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [showButtonBar]="true"
                [readonlyInput]="true"
                [required]="true"
                styleClass="w-full">
                <ng-template pTemplate="inputicon">
                  <i class="ph ph-calendar-blank pointer-events-none"></i>
                </ng-template>
              </p-calendar>
            </div>
          </div>
        </div>
      </p-fieldset>
    </form>
  </div>

  <p-divider></p-divider>

  <div class="flex flex-wrap justify-content-end gap-2 mt-4">
    <p-button label="Cancelar" severity="secondary" (onClick)="closeDialog()" />

    <p-button label="Solicitar" (onClick)="sendForm()" />

    <!-- <p-button label="PDF" (onClick)="seguroViajeFormToPDF()" /> -->
    <!-- [disabled]="seguroViajeForm.invalid"  -->
  </div>
</div>
